import { EyeIcon, EyeSlashIcon } from "@heroicons/react/16/solid";
import { InputHTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";

export interface PasswordInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  showToggle?: boolean;
  isError?: boolean;
}

export const PasswordInput = ({
  showToggle = true,
  isError = false,
  ...props
}: PasswordInputProps) => {
  const { t } = useTranslation(["commons"]);
  const [show, setShow] = useState(false);

  return (
    <>
      <div className="relative w-full">
        <input
          type={show ? "text" : "password"}
          autoComplete="current-password"
          placeholder={t("password")}
          className="input input-bordered w-full pr-10"
          {...props}
        />

        {showToggle && (
          <button
            type="button"
            onClick={() => setShow((v) => !v)}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
          >
            {show ? (
              <EyeSlashIcon className="h-5 w-5" />
            ) : (
              <EyeIcon className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      <p className="font-semibold text-error">
        {isError && t("invalidPassword")}
      </p>
    </>
  );
};
